import { IconPropTypes } from '@/legacy/types';

const DeleteIcon = ({ width = 24, height = 24, color, scale = 1, className }: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width * scale}
			height={height * scale}
			fill='none'
			viewBox='0 0 24 24'
			className={className}
		>
			<path
				stroke={color || 'currentColor'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.5}
				d='M2.25 6h19.5M4.5 6h15v14.85c0 .438-.176.857-.488 1.167-.313.31-.737.483-1.179.483H6.167c-.442 0-.866-.174-1.179-.483A1.642 1.642 0 0 1 4.5 20.85V6ZM8.25 6v-.75a3.75 3.75 0 0 1 7.5 0V6M9.75 11.25V18M14.25 11.25V18'
			/>
		</svg>
	);
};

export default DeleteIcon;
